import { mesaColorNames } from '@/src/common/theme'
import Svg, { Path, type SvgProps } from 'react-native-svg'

export function Mail(props: SvgProps) {
  return (
    <Svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      stroke={mesaColorNames['Greyscale/600 #505D64']}
      {...props}
    >
      <Path
        d="M4.583 8S10 12 12 12s7.417-4 7.417-4M4 15a3 3 0 003 3h10a3 3 0 003-3V9a3 3 0 00-3-3H7a3 3 0 00-3 3v6z"
        strokeWidth={1.5}
        strokeLinecap="round"
      />
    </Svg>
  )
}
